// extracted by mini-css-extract-plugin
module.exports = {"col_M":"col_M-37xEy6lV","box":"box-17R13Wz9"};